import { MegaraxHttpClient } from "@legacy-megarax/http-client";
import React from "react";

export const MegaraxClientContext = React.createContext<MegaraxHttpClient | undefined>(undefined);
